const manage = [
  {
    path: "/manage/profile/index",
    name: "个人资料",
    redirect: "/manage/profile/home",
    component: resolve => require(["@/view/manage/Index"], resolve),
    children: [
      {
        path: "/manage/profile/home",
        name: "机构主页",
        component: resolve => require(["@/view/manage/profile/home"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/team/teachers",
        name: "老师列表",
        component: resolve => require(["@/view/manage/team/teachers"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/student/students",
        name: "学生列表",
        component: resolve =>
          require(["@/view/manage/student/students"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/student/practiceStatistics",
        name: "practiceStatistics",
        component: resolve =>
          require(["@/view/manage/student/practiceStatistics"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/student/questions",
        name: "questionList",
        component: resolve =>
          require(["@/view/manage/student/questions"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/practice/index",
        name: "练习列表",
        component: resolve =>
          require(["@/view/manage/practice/index"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/correct/speaking",
        name: "speakingCorrect",
        component: resolve =>
          require(["@/view/manage/correct/speaking"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/correct/writing",
        name: "writingCorrect",
        component: resolve =>
          require(["@/view/manage/correct/writing"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/quizMaster/speaking",
        name: "口语批改",
        component: resolve =>
          require(["@/view/manage/quizMaster/speaking"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/quizMaster/writing",
        name: "写作批改",
        component: resolve =>
          require(["@/view/manage/quizMaster/writing"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      },
      {
        path: "/manage/systemSetting",
        name: "写作批改",
        component: resolve =>
          require(["@/view/manage/systemSetting/index"], resolve),
        meta: {
          title: "知学君",
          requireAuth: true
        }
      }
    ]
  },

  {
    path: "/manage/statistics/exam",
    name: "statisticsExam",
    component: resolve => require(["@/view/manage/statistics/exam"], resolve),
    meta: {
      title: "知学君",
      requireAuth: true
    }
  },
  {
    path: "/manage/statistics/reading",
    name: "statisticsReading",
    component: resolve =>
      require(["@/view/manage/statistics/reading"], resolve),
    meta: {
      title: "知学君",
      requireAuth: true
    }
  },
  {
    path: "/manage/statistics/listening",
    name: "statisticsListening",
    component: resolve =>
      require(["@/view/manage/statistics/listening"], resolve),
    meta: {
      title: "知学君",
      requireAuth: true
    }
  },
  {
    path: "/manage/statistics/speaking",
    name: "statisticsSpeaking",
    component: resolve =>
      require(["@/view/manage/statistics/speaking"], resolve),
    meta: {
      title: "知学君",
      requireAuth: true
    }
  },
  {
    path: "/manage/statistics/writing",
    name: "写作统计",
    component: resolve =>
      require(["@/view/manage/statistics/writing"], resolve),
    meta: {
      title: "知学君",
      requireAuth: true
    }
  },
  {
    path: "/manage/statistics/solitary",
    name: "单篇/单个统计",
    component: resolve =>
      require(["@/view/manage/statistics/solitary"], resolve),
    meta: {
      title: "知学君",
      requireAuth: true
    }
  },
  {
    path: "/manage/preview/speakingPaper",
    name: "speakingPaper",
    component: resolve =>
      require(["@/view/manage/preview/speakingPaper"], resolve),
    meta: {
      title: "知学君",
      requireAuth: true
    }
  },
  {
    path: "/manage/preview/writingPaper",
    name: "writingPaper",
    component: resolve =>
      require(["@/view/manage/preview/writingPaper"], resolve),
    meta: {
      title: "知学君",
      requireAuth: true
    }
  }
];

export default manage;



// WEBPACK FOOTER //
// ./src/router/manage/manage.js